<div class="popover-title-row">
  <span class="popover-title">{{ $title() }}</span>
  <button class="popover-close" type="button" aria-label="Close" (click)="onCancel()">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

@if ($isSkip()) {
  <div class="popover-date-row">
    <label class="popover-field">
      <span class="popover-label">From</span>
      <span class="popover-date focused">{{ $fromLabel() }}</span>
    </label>
    <label class="popover-field">
      <span class="popover-label">To</span>
      <span class="popover-date">{{ $toLabel() }}</span>
    </label>
  </div>

  <wb-mini-calendar [mode]="MiniCalendarMode.Range" [range]="$range()" (rangeChange)="onRangeChange($event)" />
} @else {
  <label class="popover-field">
    <span class="popover-label">Date</span>
    <span class="popover-date focused">{{ $dateLabel() }}</span>
  </label>

  <wb-mini-calendar [mode]="MiniCalendarMode.Single" [value]="$date()" (valueChange)="onDateChange($event)" />
}

<label class="popover-field">
  <span class="popover-label">{{ $noteLabel() }}</span>
  <input class="popover-input" type="text" [value]="$note()" (input)="onNoteInput($event)" />
</label>

@if ($showImpact()) {
  <p class="popover-impact" [class.skip]="$isSkip()" [class.extra]="!$isSkip()" aria-live="polite">{{ $impactNote() }}</p>
}

<div class="popover-footer">
  <wb-button [size]="buttonSize" [displayStyle]="secondaryStyle" label="Cancel" (onClick)="onCancel()" />
  <wb-button [size]="buttonSize" [displayStyle]="primaryStyle" [label]="$confirmLabel()" (onClick)="onConfirm()" />
</div>
